/**
 * Vue plugin for integrating and customizing VueSummernote.
 *
 * Responsibilities:
 * 1. Install VueSummernote with a centralized configuration (toolbar, popover, buttons).
 * 2. Patch the vue-summernote component with custom mixins (imageWrapperMixin)
 *    by calling extendSummernoteComponent().
 *
 * Usage:
 *   import SummernotePlugin from '@/plugins/summernote';
 *   Vue.use(SummernotePlugin);
 *
 * This encapsulates all Summernote setup and customizations
 * in a single, maintainable place.
 */

import VueSummernote from "vue-summernote";
import { extendSummernoteComponent } from "@/plugins/summernote/ExtendComponent";
import { summernoteConfig } from "@/plugins/summernote/config";
import {registerResizeThreeQuarter} from "@/plugins/summernote/ResizThreeQuarter";

export default {
    /**
     * Vue plugin install method
     * @param {VueConstructor} Vue - the Vue constructor
     */
    install(Vue) {
        // Install the official VueSummernote plugin with config
        registerResizeThreeQuarter()
        Vue.use(VueSummernote, summernoteConfig);

        // Extend the component with custom image wrapper logic
        extendSummernoteComponent();
    }
};
